export default "__VITE_PUBLIC_ASSET__ae876d77__"